
import axios from "axios";
import { OutputBaseProps } from "utils/types/API";
import { DataItemProps } from ".";
import { AppMessage } from "components";
import { StepItemProps } from "apis/step";
import { FormItemProps } from "apis/form";
import { WorkflowItemProps } from "apis/workflow";
import { FieldItemProps } from "apis/field";

interface ApiDataInitInputProps {
    id?: number;
    stepId?: number;
}

interface Search {
    page: number
    pageSize: number
    fields: string
    q: any
}

export type Apis = Record<string, {
    formId: number;
    fields?: string | null;
    method?: string;
    url?: string;
    search?: Record<string, string | number | null | undefined>;
}>

export type Dependencies = Record<string, FieldItemProps[]>;

export interface ResApiDataInitProps {
    uid: string;
    item: DataItemProps;
    workflow?: WorkflowItemProps;
    form?: FormItemProps;
    fields?: FieldItemProps[];
    step?: StepItemProps;
    options?: {
        [key: string]: DataItemProps[];
    };
    apis?: Apis;
    dependencies?: Dependencies;
    locales?: string[];
    translate?: Record<string, Record<string, string | null>>;
}
export type ApiDataInitOutputProps = OutputBaseProps<ResApiDataInitProps, ApiDataInitInputProps>

export const apiDataInit = async (data: ApiDataInitInputProps, formCode: string) => {
    const res = (await axios.post<ApiDataInitOutputProps>(`/api/data/${formCode}/init`, data))
        .data;
    // if (res.code === 0 && res.data) {
    //     AppMessage.success({
    //         title: "Thông báo",
    //         message: res.message
    //     })
    // }
    return res;
};


export const apiDataIdInit = async (data: ApiDataInitInputProps, formId: number) => {
    const res = (await axios.post<ApiDataInitOutputProps>(`/api/data/id/${formId}/init`, data))
        .data;
    // if (res.code === 0 && res.data) {
    //     AppMessage.success({
    //         title: "Thông báo",
    //         message: res.message
    //     })
    // }
    return res;
};